import React from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "@apollo/client";

import { GET_WATER_SOURCE_NO_LOCATION_DATA } from "../../../queries/archiveQrys/secureQrys/statewideReportQry";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";
import ChartLegend from "../../reuseableComponents/graphsAndCharts/ChartLegend";
import DeqPieChart from "../../reuseableComponents/graphsAndCharts/DeqPieChart";

const WaterSourceNoLocationDataChart = () => {
  const { loading, data, error } = useQuery(GET_WATER_SOURCE_NO_LOCATION_DATA);
  if (loading || error) {
    return (
      <>
        <Row>
          <Col>
            <h3>Water Sources Without Location Data</h3>
          </Col>
        </Row>
        <Row>
          <Col>{loading ? <SkeletonLoader width='100%' /> : error ? <ErrorHandler error={error} /> : ""}</Col>
        </Row>
      </>
    );
  }
  const colors = ["#0080b7", "#00afd8", "#add361"];

  return (
    <>
      <Row>
        <Col>
          <h3>Water Sources Without Location Data</h3>
        </Col>
      </Row>
      <Row>
        <Col cypressid='wtrSourcesNoLocationLegend'>
          <ChartLegend data={data.getSourceWithoutLocationStats} colorArray={colors} />
        </Col>
      </Row>
      <Row>
        <Col cypressid='wtrSourcesNoLocationChart'>
          <DeqPieChart data={data.getSourceWithoutLocationStats} colorArray={colors} />
        </Col>
      </Row>
    </>
  );
};
export default WaterSourceNoLocationDataChart;
